import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { BidFormValues } from "../admin/bids/types";

/**
 * Where the party happens. Split out of ContactInfoFields, which had grown to
 * cover both the person and the venue, so the admin bid page can put its
 * contact list next to the other contact fields.
 */
export const EventLocationFields = ({
  form,
}: {
  form: UseFormReturn<BidFormValues>;
}) => {
  return (
    <>
      <FormField
        control={form.control}
        name="address"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Event Address (or Party Barn)</FormLabel>
            <FormControl>
              <Input
                maxLength={255}
                placeholder="123 Main St, City, State, ZIP"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="city"
        render={({ field }) => (
          <FormItem>
            <FormLabel>City</FormLabel>
            <FormControl>
              <Input
                maxLength={255}
                placeholder="Anytown"
                {...field}
                value={field.value as string}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="nameOfLocation"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Name of Location/Venue</FormLabel>
            <FormControl>
              <Input
                maxLength={255}
                placeholder="e.g. Community Center, Mary's House"
                {...field}
                value={field.value as string}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
